<div mat-dialog-title>
  <div i18n>Настройки чтения модели</div>
  <button mat-icon-button [mat-dialog-close] aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content>
  <div i18n>При расчете стоимости заказа учитывать</div>
  <div class="flex flex-col items-start">
    <mat-checkbox [(ngModel)]="checkFurniture" i18n>Фурнитуру</mat-checkbox>
    <mat-checkbox [(ngModel)]="checkAssembly" i18n>Покупные изделия</mat-checkbox>
  </div>
  <mat-divider class="my-4"></mat-divider>
  <div i18n>Данные настройки доступны только менеджеру</div>
</div>

<div mat-dialog-actions>
  <button i18n mat-raised-button color="accent" [mat-dialog-close]="{checkAssembly, checkFurniture}">ОК</button>
  <button i18n mat-button [mat-dialog-close]>ОТМЕНА</button>
</div>
